import React from "react";
import {
  defineBlock,
  smartProps,
  useSmartProp,
  useInspectorControl,
  useEditor,
} from "@smartfire/gutenberg-react";
import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import {
  PanelBody,
  PanelRow,
  TextControl,
  SelectControl,
  CheckboxControl,
} from "@wordpress/components";
import style from "./block.module.scss";
import Button from "../shared/button-icon";
import { Button as ButtonAdmin } from "@wordpress/components";
import { ReactComponent as IconVerre } from "../assets/verreIcon.svg";
import { ReactComponent as DownloadIcon } from "../assets/download.svg";

const ALLOWED_MEDIA_TYPES = ["application/pdf"];

function Inspector() {
  const [textButton, setTextButton] = useSmartProp("textButton");
  const [typeButton, setTypeButton] = useSmartProp("typeButton");
  const [file, setFile] = useSmartProp("file");
  const [link, setLink] = useSmartProp("link");
  const [external, setExternal] = useSmartProp("external");
  return (
    <>
      <PanelBody title="Configuration bouton" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Texte bouton"}
            value={textButton}
            onChange={(value) => setTextButton(value)}
          />
        </PanelRow>
        <PanelRow>
          <SelectControl
            width={"100%"}
            label="Choix du bouton"
            value={typeButton}
            options={[
              { label: "Téléchargement", value: "download" },
              { label: "Lien 1", value: "link1" },
              { label: "Lien 2", value: "link2" },
            ]}
            onChange={(typeButton) => {
              setTypeButton(typeButton);
            }}
          />
        </PanelRow>
        {typeButton !== "download" && (
          <PanelRow>
            <TextControl
              label={"Lien Bouton"}
              value={link}
              onChange={(value) => setLink(value)}
            />
          </PanelRow>
        )}
        {typeButton === "download" && (
          <>
            <PanelRow>
              Fichier pdf actuel : {file ? file.filename : "Pas de fichier"}
            </PanelRow>
            <PanelRow>
              <MediaUploadCheck>
                <MediaUpload
                  onSelect={(file) => setFile(file)}
                  allowedTypes={ALLOWED_MEDIA_TYPES}
                  value={file ? file.id : null}
                  render={({ open }) => (
                    <ButtonAdmin isDefault onClick={open}>
                      Config fichier pdf
                    </ButtonAdmin>
                  )}
                />
              </MediaUploadCheck>
            </PanelRow>
          </>
        )}
        {typeButton !== "download" && (
          <PanelRow>
            <CheckboxControl
              label={"Lien dans un nouvel onglet"}
              checked={external}
              onChange={() =>
                external ? setExternal(false) : setExternal(true)
              }
            />
          </PanelRow>
        )}
      </PanelBody>
    </>
  );
}

function Block({ textButton, typeButton, file, link, external }) {
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();
  return (
    <div className={style.block}>
      {typeButton === "download" && file && (
        <Button
          classIcon={style.icon}
          Icon={DownloadIcon}
          textColor={style.blueText}
          className={style.buttonDownload}
          external
          {...(isEditing ? { href: "" } : { href: file.url })}
        >
          {textButton}
        </Button>
      )}
      {typeButton === "link1" && link && (
        <Button
          classIcon={style.icon}
          Icon={IconVerre}
          className={style.buttonClassement}
          textColor={style.blueText}
          external={external}
          {...(isEditing ? { href: "" } : { href: link })}
        >
          {textButton}
        </Button>
      )}
      {typeButton === "link2" && link && (
        <div className={style.buttonSeeMore}>
          <a
            {...(isEditing ? { href: "" } : { href: link })}
            {...(external ? { target: "_blank" } : {})}
          >
            {textButton}
          </a>
        </div>
      )}
      {link === "" && (typeButton === "link2" || typeButton === "link1") && (
        <div>Button not activated</div>
      )}
      {file === undefined && typeButton === "download" && (
        <div>Button not activated</div>
      )}
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    textButton: smartProps.string.withDefault(""),
    typeButton: smartProps.string.withDefault("download"),
    file: smartProps.any.withDefault(""),
    link: smartProps.string.withDefault(""),
    external: smartProps.bool.withDefault(false),
  },
  setup: {
    title: "Button Selection",
  },
});
